









import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import Dialog from '@/components/dialog.vue';
import AddAcct from './add-acct.vue';
import EditAcct from './edit-acct.vue';
import EditWhite from './edit-white.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
import { role, dpt, grp } from '@/unite/role';
@Component({
  components: { SearchPaginationTable, Dialog, AddAcct, EditAcct, EditWhite }
})
export default class RunningwaterDetails extends Vue {
  mounted() {
    this.getRole();
    this.getDpt();
    this.getGrp();
  }
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  optionTitle: string = '';
  visible: boolean = false;
  visibleAdd: boolean = false;
  visibleEdit: boolean = false;
  visibleWhite: boolean = false;
  sendData: any;
  roleList: object[] = [];
  dptList: object[] = [];
  grpList: object[] = [];
  isRole: boolean = role();
  isDpt: boolean = dpt();
  isGrp: boolean = grp();
  modifyForm: any;
  rules: any[] = [];
  pageData: any = {
    url: '/back/v1/acct/list',
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: this.isRole || this.isDpt || this.isGrp, // 是否需要头部操作按钮
    info: {
      role: '',
      grp_id: '',
      dpt_id: '',
      page_num: 10,
      page_index: 1
    }, // 传后端数据
    searchData: [],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '添加账号',
        methods: 'add',
        type: 'success',
        loading: false
      },
      {
        name: '导出账号',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID'
        // },
        {
          prop: 'account',
          label: '账号'
        },
        {
          prop: 'nick_name',
          label: '昵称'
        },
        {
          prop: 'depart_name',
          label: '部门'
        },
        {
          prop: 'group_name',
          label: '分组'
        },
        {
          prop: 'enable',
          _prop: 'disable',
          label: '是否启用',
          type: 'switch',
          status: {
            true: false,
            false: true
          }
        },
        {
          prop: '_online',
          _prop: 'online',
          label: '是否在线',
          color: 'online',
          type: 'tag',
          status: {
            true: '在线',
            false: '不在线'
          }
        },
        {
          prop: 'pv',
          label: 'PV',
          type: 'pv'
        },
        {
          prop: 'sv',
          label: 'SV',
          type: 'sv'
        },
        {
          prop: 'IpBind',
          label: '白名单',
          type: 'bindSub'
        },
        {
          prop: 'last_login_at',
          label: '最后登录时间',
          type: 'time'
        },
        {
          prop: 'last_login_ip',
          label: '最后登录IP'
        }
      ],
      expand: [],
      optionWidth: 210,
      option: [
        {
          name: '修改账号',
          methods: 'modify',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '清空验证',
          methods: 'empty',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '删除',
          methods: 'delete',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '白名单',
          methods: 'whitelist',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  private handleClick(methods: string, row: any) {
    this.sendData = row;
    if (methods === 'modify') {
      this.visibleEdit = true;
    } else if (methods === 'enable') {
      this.publicApi(
        `/back/v1/acct/enable?id=${row.id}&enable=${!row.enable}`,
        `是否确认${!row.enable ? '禁用' : '开启'}${row.account}`,
        {}
      );
    } else if (methods === 'empty') {
      this.publicApi(
        `/back/v1/acct/clean?id=${row.id}`,
        `是否确认清空${row.account}验证`,
        {}
      );
    } else if (methods === 'delete') {
      this.publicApi(
        `/back/v1/acct/delete?id=${row.id}`,
        `是否确认删除${row.account}`,
        {}
      );
    } else if (methods === 'whitelist') {
      this.visibleWhite = true;
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.visibleAdd = true;
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
    this.visibleAdd = false;
    this.visibleEdit = false;
    this.visibleWhite = false;
  }
  private getRole() {
    if (this.isRole) {
      get('/back/v1/common/roles', {}).then(d => {
        // @ts-ignore
        d.Content.forEach(item => {
          this.roleList = [
            ...this.roleList,
            { label: item.Desc, value: item.Value }
          ];
        });
        this.pageData.searchData.push({
          type: 'select', // text框
          model: 'role', // 字段
          tip: '角色',
          data: this.roleList
        });
      });
    }
  }
  private getDpt() {
    if (this.isDpt) {
      get('/back/v1/dpt/list?page_index=1&page_num=10000', {}).then(d => {
        // @ts-ignore
        d.Content.list.forEach(item => {
          this.dptList = [
            ...this.dptList,
            { label: item.name, value: item.id }
          ];
        });
        this.pageData.searchData.push({
          type: 'select', // text框
          model: 'dpt_id', // 字段
          tip: '部门',
          data: this.dptList
        });
      });
    }
  }
  private getGrp() {
    if (this.isGrp) {
      get('/back/v1/cg/list?page_index=1&page_num=10000', {}).then(d => {
        // @ts-ignore
        d.Content.list.forEach(item => {
          this.grpList = [
            ...this.grpList,
            { label: item.name, value: item.id }
          ];
        });
        this.pageData.searchData.push({
          type: 'select', // text框
          model: 'grp_id', // 字段
          tip: '分组',
          data: this.grpList
        });
      });
    }
  }
  // 公共方法
  publicApi(url: string, msg: string, Infodata: any) {
    this.$confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        get(url, Infodata)
          .then(d => {
            // @ts-ignore
            this.$refs.table.getData();
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          })
          .catch(e => {
            // @ts-ignore
            this.$refs.table.getData();
          });
      })
      .catch(() => {
        // @ts-ignore
        this.$refs.table.getData();
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
  }
}
